<template>
  <DialogWrapper
    class="mobile-preview"
    showClose
    destroyOnClose
    closeOnCancel
    hideFooter
    width="540px"
    :show.sync="isShow"
    :close-on-click-modal="false"
    :loading="loading"
    @cancel="handelCancel"
  >
    <CompanyDetail
      v-rect-loading="loading"
      class="company-info-preview"
      :footerData="footerData"
      :pageData="pageData"
      :companyBaseInfo="companyBaseInfo"
      :isPreview="true"
      :activePage="activePage"
    />
  </DialogWrapper>
</template>

<script>
// import '@vant/touch-emulator'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import { COMPANY_PAGE_TYPE, CUSTOM_LANDING_PAGE_TYPE } from '@/constant/company'
import CompanyDetail from '@/views/company/mobile/companyInfo/components/companyDetail.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    DialogWrapper,
    CompanyDetail
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    customSetting: {
      required: true
    },
    otherCustomSetting: {
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.job.editor',
      loading: false,
      companyBaseInfo: null,
      pageData: null,
      footerData: null,
      activePage: null
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    ...mapActions('company', ['getCompanyTheme', 'clearCompanyThemeSetting']),
    async loadCompanyTheme () {
      this.loading = true
      await this.getCompanyTheme({
        companyId: this.customSetting.company.id
      })
      this.loading = false
    },
    handelCancel () {
      this.isShow = false
    },
    formatBaseCompanyInfo () {
      const company = this.customSetting.company
      const companyBaseInfo = {
        company: {
          logo: company.logo,
          id: company.id
        },
        show_survey_entrance: company.company_survey.show_survey,
        has_answered: company.company_survey.has_answered
      }

      this.companyBaseInfo = companyBaseInfo
    },
    formatPageData () {
      const customSetting = this.customSetting
      const pageData = {
        webpageItems: customSetting.customContentList,
        showGap: customSetting.company_webpage_setting.show_gap,
        header_image: customSetting.company_webpage_setting.webpage_header_image_key,
        title: customSetting.company_webpage_setting.webpage_title,
        slogan: customSetting.company_webpage_setting.webpage_slogan,
        video_navigation: {
          video_list: customSetting.company_webpage_setting.video_navigation_list
        }
      }

      this.pageData = pageData
    },
    formatFooterData () {
      const customSetting = this.customSetting
      const otherCustomSetting = this.otherCustomSetting
      const footerData = {}
      const currentPageIsBranding = [CUSTOM_LANDING_PAGE_TYPE.COMPANY_INFO, CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_COMPANY_INFO].includes(customSetting.page_num)
      const currentPageMenu = customSetting.company_webpage_setting.webpage_menu
      const otherPageMenu = otherCustomSetting.company_webpage_setting.is_activated && otherCustomSetting.company_webpage_setting.webpage_menu
      footerData.branding_page = {
        i18nName: currentPageIsBranding ? currentPageMenu : otherPageMenu
      }
      footerData.landing_page = {
        i18nName: currentPageIsBranding ? otherPageMenu : currentPageMenu
      }
      footerData.has_custom_mobile_landing_page = currentPageIsBranding ? otherCustomSetting.company_webpage_setting.is_activated : customSetting.company_webpage_setting.is_activated

      this.footerData = footerData
    },
    formatActivePage () {
      const brandingPageNumList = [CUSTOM_LANDING_PAGE_TYPE.COMPANY_INFO, CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_COMPANY_INFO]
      this.activePage = brandingPageNumList.includes(this.customSetting.page_num) ? COMPANY_PAGE_TYPE.BRANDING : COMPANY_PAGE_TYPE.LANDING
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.formatBaseCompanyInfo()
        this.formatPageData()
        this.formatFooterData()
        this.formatActivePage()
        this.loadCompanyTheme()
      } else {
        this.clearCompanyThemeSetting()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-preview {
  .company-info-preview {
    min-height: 200px;
    max-height: 76vh;
    overflow: auto;
    background-color: #f7f7f7;
    border: 1px solid #eee;

    ::v-deep {
      .mobile-header {
        .header-bg {
          height: 300px;
        }
      }

      .custom-content-list {
        .custom-content {
          .picture-previewer {
            .picture-list {
              .picture-item {
                .picture-wrapper {
                  height: 96px;
                }
              }
            }
          }

          .video-previewer {
            .video-wrapper {
              .player {
                .play-icon {
                  width: 80px;
                  height: 80px;
                  line-height: 80px;
                  padding-left: 10px;
                  font-size: 40px;

                  &::before {
                    left: 16px;
                  }
                }
              }
            }
          }
        }
      }

      .footer {
        .btn-list {
          position: absolute;
          left: 50px;
          right: 40px;
          bottom: 20px;
          border: 1px solid #ddd;
          width: auto;
        }
      }

      .video-navigation-container {
        position: absolute;
        margin: 15px 70px 15px 75px;

        .video-swiper {
          left: 50px;
          right: 40px;
          bottom: 20px;

          .close-btn {
            right: 45px;
          }
        }
      }
    }
  }

  ::v-deep {
    .el-dialog__body {
      word-break: break-word;
      transform: translate(0, 0);
      overflow: hidden;
    }
  }
}
</style>
